import StorageService from "./storage";
import {AppSettings} from "application";

export const persistAuthenticationToken = (token) => {
  StorageService.setItem(AppSettings.ticketName, token);
};

export const invalidAuthenticationToken = () => {
  StorageService.removeItem(AppSettings.ticketName);
};

export const AuthService = {
  persistAuthenticationToken,
  invalidAuthenticationToken
};

export default AuthService;
